import Vue from 'vue'
import VueRouter from 'vue-router'
import index from '@/components/index'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'hash',
  base: __dirname,
  //路由映射map
  routes: [
    { path: '/', redirect: '/index'},
    { path: '*', redirect: '/index' },
    {
      path: '/index',
      name: 'index',
      component: index,
    },

  ]
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js